import { useState, useEffect, useMemo } from "react";
const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });
const toMin = t => { if(!t) return 0; const [hh,mm]=(t||"").split(":").map(Number); return hh*60+(mm||0); };
const calcH = (dam,fam,dpm,fpm) => {
  let t=0;
  if(dam&&fam) t+=Math.max(0,toMin(fam)-toMin(dam));
  if(dpm&&fpm) t+=Math.max(0,toMin(fpm)-toMin(dpm));
  return Math.round(t*10/60)/10;
};
const fmtH = h => { const hh=Math.floor(h), mm=Math.round((h-hh)*60); return `${hh}h${mm>0?mm.toString().padStart(2,"0"):""}`;  };
const MOIS = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];

export default function HeuresView({ T, user, techniciens=[], interventions=[] }) {
  const now = new Date();
  const [mois, setMois] = useState(now.getMonth()+1);
  const [annee, setAnnee] = useState(now.getFullYear());
  const [tab, setTab] = useState("dashboard"); // dashboard | saisie | validation | recup
  const [dashboard, setDashboard] = useState([]);
  const [feuilles, setFeuilles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    technicien_id:"", intervention_id:"", date_journee:new Date().toISOString().split("T")[0],
    heure_debut_am:"08:00", heure_fin_am:"12:00",
    heure_debut_pm:"13:30", heure_fin_pm:"17:00",
    heures_normales:7, notes:"", deplacements_km:0
  });
  const [saving, setSaving] = useState(false);
  const [recupForm, setRecupForm] = useState({date_debut:"",date_fin:"",heures:"",motif:""});

  const load = async () => {
    setLoading(true);
    const [dash, feuilles] = await Promise.all([
      fetch(`${BASE}/heures/dashboard?mois=${mois}&annee=${annee}`,{headers:h()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/heures?mois=${mois}&annee=${annee}`,{headers:h()}).then(r=>r.json()).catch(()=>[]),
    ]);
    setDashboard(Array.isArray(dash)?dash:[]);
    setFeuilles(Array.isArray(feuilles)?feuilles:[]);
    setLoading(false);
  };

  useEffect(()=>{ load(); },[mois,annee,tab]);

  const heuresForm = useMemo(()=>calcH(form.heure_debut_am,form.heure_fin_am,form.heure_debut_pm,form.heure_fin_pm),[form]);
  const heureSup = Math.max(0, heuresForm - form.heures_normales);
  const finTot = form.heure_fin_pm||form.heure_fin_am||"";
  const finMin = toMin(finTot);
  const journeeFinie = finMin > 0 && finMin < toMin("16:30");

  const saveFeuille = async () => {
    setSaving(true);
    const resp = await fetch(`${BASE}/heures`,{method:"POST",headers:h(),body:JSON.stringify({...form,technicien_id:form.technicien_id||user.id})});
    if(resp.ok){ setForm(p=>({...p,notes:"",deplacements_km:0})); load(); }
    setSaving(false);
  };

  const valider = async(id, statut) => {
    await fetch(`${BASE}/heures/${id}/valider`,{method:"PATCH",headers:h(),body:JSON.stringify({statut})});
    load();
  };

  const aValider = feuilles.filter(f=>f.statut==="soumis");
  const totalSupMois = dashboard.reduce((s,t)=>s+(parseFloat(t.heures_sup)||0),0);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{fontSize:22,fontWeight:800,color:T.text,letterSpacing:"-0.5px"}}>⏱️ Gestion des heures</div>
          <div style={{fontSize:13,color:T.muted,marginTop:2}}>{MOIS[mois-1]} {annee}</div>
        </div>
        <div style={{display:"flex",gap:6}}>
          <select value={mois} onChange={e=>setMois(+e.target.value)}
            style={{padding:"7px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:13,outline:"none"}}>
            {MOIS.map((m,i)=><option key={i} value={i+1}>{m}</option>)}
          </select>
          <select value={annee} onChange={e=>setAnnee(+e.target.value)}
            style={{padding:"7px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:13,outline:"none"}}>
            {[2024,2025,2026,2027].map(y=><option key={y}>{y}</option>)}
          </select>
        </div>
        {/* Tabs */}
        <div style={{display:"flex",background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:3,gap:2}}>
          {[["dashboard","📊 Vue globale"],["saisie","✏️ Saisir"],["validation","✅ Valider"+(aValider.length>0?` (${aValider.length})`:"")],["recup","🔄 Récup"]].map(([v,l])=>(
            <button key={v} onClick={()=>setTab(v)}
              style={{padding:"6px 14px",borderRadius:7,border:"none",background:tab===v?T.accent:"transparent",color:tab===v?"#fff":T.muted,fontSize:12,fontWeight:tab===v?700:500,cursor:"pointer",transition:"all 0.15s",whiteSpace:"nowrap"}}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {/* ── DASHBOARD ── */}
      {tab==="dashboard"&&(<>
        {/* KPIs */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10}}>
          {[
            {lbl:"Heures sup ce mois",val:fmtH(totalSupMois),c:"#ef4444",ic:"⚡"},
            {lbl:"Feuilles à valider",val:aValider.length,c:"#f59e0b",ic:"⏳"},
            {lbl:"Techniciens actifs",val:dashboard.filter(t=>t.heures_realisees>0).length,c:"#10b981",ic:"👷"},
            {lbl:"Total heures réalisées",val:fmtH(dashboard.reduce((s,t)=>s+(parseFloat(t.heures_realisees)||0),0)),c:"#4361EE",ic:"📊"},
          ].map(k=>(
            <div key={k.lbl} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"14px 16px",borderTop:`3px solid ${k.c}`}}>
              <div style={{fontSize:11,color:T.muted,marginBottom:4}}>{k.ic} {k.lbl}</div>
              <div style={{fontSize:24,fontWeight:800,color:k.c}}>{k.val}</div>
            </div>
          ))}
        </div>
        {/* Table techniciens */}
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{background:T.bg}}>
              {["Technicien","Heures réalisées","Heures sup","Récup acquis","Récup pris","Solde","Feuilles","À valider"].map(c=>(
                <th key={c} style={{padding:"11px 14px",textAlign:"left",fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{c}</th>
              ))}
            </tr></thead>
            <tbody>
              {dashboard.map(t=>{
                const solde=(parseFloat(t.recup_acquises)||0)-(parseFloat(t.recup_prises)||0);
                return(
                  <tr key={t.id} style={{borderBottom:`1px solid ${T.border}`}} onMouseEnter={e=>e.currentTarget.style.background=T.bg} onMouseLeave={e=>e.currentTarget.style.background=""}>
                    <td style={{padding:"12px 14px",fontWeight:700,color:T.text,fontSize:13}}>{t.nom}</td>
                    <td style={{padding:"12px 14px",fontSize:13,color:T.text}}>{fmtH(t.heures_realisees)}</td>
                    <td style={{padding:"12px 14px"}}>
                      {parseFloat(t.heures_sup)>0
                        ?<span style={{fontSize:13,fontWeight:700,color:"#ef4444",background:"rgba(239,68,68,0.08)",padding:"2px 8px",borderRadius:99}}>+{fmtH(t.heures_sup)}</span>
                        :<span style={{fontSize:13,color:T.muted}}>—</span>}
                    </td>
                    <td style={{padding:"12px 14px",fontSize:13,color:"#10b981",fontWeight:600}}>{fmtH(t.recup_acquises)}</td>
                    <td style={{padding:"12px 14px",fontSize:13,color:T.muted}}>{fmtH(t.recup_prises)}</td>
                    <td style={{padding:"12px 14px"}}>
                      <span style={{fontSize:13,fontWeight:700,color:solde>0?"#10b981":solde<0?"#ef4444":T.muted}}>{solde>0?"+":""}{fmtH(Math.abs(solde))}</span>
                    </td>
                    <td style={{padding:"12px 14px",fontSize:13,color:T.muted}}>{t.nb_feuilles}</td>
                    <td style={{padding:"12px 14px"}}>
                      {parseInt(t.a_valider)>0&&<span style={{fontSize:11,fontWeight:700,color:"#f59e0b",background:"rgba(245,158,11,0.1)",padding:"2px 8px",borderRadius:99}}>{t.a_valider} en attente</span>}
                    </td>
                  </tr>
                );
              })}
              {dashboard.length===0&&<tr><td colSpan={8} style={{textAlign:"center",padding:40,color:T.muted}}>Aucune donnée ce mois</td></tr>}
            </tbody>
          </table>
        </div>
      </>)}

      {/* ── SAISIE ── */}
      {tab==="saisie"&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:20,display:"flex",flexDirection:"column",gap:14}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text}}>📝 Nouvelle feuille de temps</div>
            
            {user.role==="admin"&&(
              <div>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:4}}>Technicien</label>
                <select value={form.technicien_id} onChange={e=>setForm(p=>({...p,technicien_id:e.target.value}))}
                  style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}>
                  <option value="">Moi-même</option>
                  {techniciens.map(t=><option key={t.id} value={t.id}>{t.prenom} {t.nom}</option>)}
                </select>
              </div>
            )}

            <div>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:4}}>Date</label>
              <input type="date" value={form.date_journee} onChange={e=>setForm(p=>({...p,date_journee:e.target.value}))}
                style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
            </div>

            <div>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:4}}>Intervention liée (optionnel)</label>
              <select value={form.intervention_id} onChange={e=>setForm(p=>({...p,intervention_id:e.target.value}))}
                style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}>
                <option value="">— Aucune —</option>
                {interventions.filter(i=>["en_cours","planifiee","terminee"].includes(i.statut)).slice(0,30).map(i=><option key={i.id} value={i.id}>{i.titre||i.client_nom}</option>)}
              </select>
            </div>

            {/* Créneaux AM/PM */}
            <div style={{background:T.bg,borderRadius:10,padding:14,display:"flex",flexDirection:"column",gap:10}}>
              <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px"}}>🌅 Matin</div>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <div style={{flex:1}}>
                  <label style={{fontSize:10,color:T.muted,display:"block",marginBottom:3}}>Début</label>
                  <input type="time" value={form.heure_debut_am} onChange={e=>setForm(p=>({...p,heure_debut_am:e.target.value}))}
                    style={{width:"100%",padding:"8px 10px",borderRadius:8,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:14,fontWeight:700,outline:"none"}}/>
                </div>
                <span style={{color:T.muted,marginTop:14}}>→</span>
                <div style={{flex:1}}>
                  <label style={{fontSize:10,color:T.muted,display:"block",marginBottom:3}}>Fin</label>
                  <input type="time" value={form.heure_fin_am} onChange={e=>setForm(p=>({...p,heure_fin_am:e.target.value}))}
                    style={{width:"100%",padding:"8px 10px",borderRadius:8,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:14,fontWeight:700,outline:"none"}}/>
                </div>
              </div>
              <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginTop:4}}>🌆 Après-midi</div>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <div style={{flex:1}}>
                  <label style={{fontSize:10,color:T.muted,display:"block",marginBottom:3}}>Début</label>
                  <input type="time" value={form.heure_debut_pm} onChange={e=>setForm(p=>({...p,heure_debut_pm:e.target.value}))}
                    style={{width:"100%",padding:"8px 10px",borderRadius:8,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:14,fontWeight:700,outline:"none"}}/>
                </div>
                <span style={{color:T.muted,marginTop:14}}>→</span>
                <div style={{flex:1}}>
                  <label style={{fontSize:10,color:T.muted,display:"block",marginBottom:3}}>Fin</label>
                  <input type="time" value={form.heure_fin_pm} onChange={e=>setForm(p=>({...p,heure_fin_pm:e.target.value}))}
                    style={{width:"100%",padding:"8px 10px",borderRadius:8,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:14,fontWeight:700,outline:"none"}}/>
                </div>
              </div>
            </div>

            <div style={{display:"flex",gap:10}}>
              <div style={{flex:1}}>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:4}}>H. normales / jour</label>
                <input type="number" value={form.heures_normales} onChange={e=>setForm(p=>({...p,heures_normales:+e.target.value}))} step="0.5"
                  style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
              </div>
              <div style={{flex:1}}>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:4}}>Déplacements (km)</label>
                <input type="number" value={form.deplacements_km} onChange={e=>setForm(p=>({...p,deplacements_km:+e.target.value}))}
                  style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
              </div>
            </div>

            <textarea value={form.notes} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} placeholder="Notes..."
              rows={2} style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none",resize:"vertical",fontFamily:"inherit"}}/>

            <button onClick={saveFeuille} disabled={saving||!form.date_journee||heuresForm===0}
              style={{padding:"12px",borderRadius:10,background:T.gradient||T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",opacity:(saving||heuresForm===0)?0.6:1}}>
              {saving?"⏳ Envoi...":"📤 Soumettre la feuille"}
            </button>
          </div>

          {/* Récap temps réel */}
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:20}}>
              <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:16}}>📊 Récapitulatif journée</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {[
                  {lbl:"Heures réalisées",val:fmtH(heuresForm),c:heuresForm>=form.heures_normales?"#10b981":"#f59e0b",big:true},
                  {lbl:"Heures normales",val:fmtH(form.heures_normales),c:T.muted},
                  {lbl:"Heures sup",val:heureSup>0?"+"+fmtH(heureSup):"—",c:heureSup>0?"#ef4444":T.muted},
                  {lbl:"Fin de journée",val:finTot||"—",c:T.text},
                ].map(k=>(
                  <div key={k.lbl} style={{background:T.bg,borderRadius:10,padding:"12px 14px"}}>
                    <div style={{fontSize:10,color:T.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>{k.lbl}</div>
                    <div style={{fontSize:k.big?28:18,fontWeight:800,color:k.c}}>{k.val}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Alerte fin anticipée */}
            {journeeFinie&&(
              <div style={{background:"rgba(99,102,241,0.08)",border:"1px solid rgba(99,102,241,0.3)",borderRadius:12,padding:"14px 16px"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#6366f1",marginBottom:6}}>💡 Journée terminée tôt !</div>
                <div style={{fontSize:12,color:"#4338ca",lineHeight:1.6}}>
                  Fin à {finTot} — Il reste du temps disponible.<br/>
                  Des interventions sont peut-être disponibles dans votre secteur.
                </div>
                <button style={{marginTop:10,padding:"8px 14px",borderRadius:8,background:"#6366f1",border:"none",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                  🔍 Voir les interventions proches
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── VALIDATION ── */}
      {tab==="validation"&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <div style={{fontSize:13,color:T.muted}}>{aValider.length} feuille(s) en attente de validation</div>
          {feuilles.filter(f=>f.statut==="soumis").map(f=>(
            <div key={f.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"14px 18px",display:"flex",alignItems:"center",gap:16}}>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:700,color:T.text}}>{f.technicien_nom||"Technicien"}</div>
                <div style={{fontSize:12,color:T.muted,marginTop:2}}>{new Date(f.date_journee).toLocaleDateString("fr-FR",{weekday:"long",day:"2-digit",month:"long"})} · {f.intervention_titre||"Sans intervention"}</div>
                <div style={{display:"flex",gap:12,marginTop:6,fontSize:12}}>
                  {f.heure_debut_am&&f.heure_fin_am&&<span>🌅 {f.heure_debut_am.slice(0,5)}→{f.heure_fin_am.slice(0,5)}</span>}
                  {f.heure_debut_pm&&f.heure_fin_pm&&<span>🌆 {f.heure_debut_pm.slice(0,5)}→{f.heure_fin_pm.slice(0,5)}</span>}
                  <span style={{fontWeight:700,color:T.accent}}>⏱ {fmtH(f.heures_realisees||0)}</span>
                  {parseFloat(f.heures_sup)>0&&<span style={{color:"#ef4444",fontWeight:700}}>+{fmtH(f.heures_sup)} sup</span>}
                  {f.deplacements_km>0&&<span style={{color:T.muted}}>🚗 {f.deplacements_km} km</span>}
                </div>
                {f.notes&&<div style={{fontSize:11,color:T.muted,marginTop:4,fontStyle:"italic"}}>{f.notes}</div>}
              </div>
              <div style={{display:"flex",gap:8,flexShrink:0}}>
                <button onClick={()=>valider(f.id,"refuse")} style={{padding:"8px 14px",borderRadius:8,border:"1px solid rgba(239,68,68,0.3)",background:"rgba(239,68,68,0.08)",color:"#ef4444",fontSize:12,fontWeight:600,cursor:"pointer"}}>✕ Refuser</button>
                <button onClick={()=>valider(f.id,"valide")} style={{padding:"8px 14px",borderRadius:8,border:"none",background:"#10b981",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>✓ Valider</button>
              </div>
            </div>
          ))}
          {aValider.length===0&&<div style={{textAlign:"center",padding:60,color:T.muted}}>✅ Aucune feuille en attente</div>}
        </div>
      )}

      {/* ── RÉCUP ── */}
      {tab==="recup"&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:20}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:16}}>🔄 Demande de récupération</div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <div style={{display:"flex",gap:10}}>
                <div style={{flex:1}}>
                  <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:4}}>Du</label>
                  <input type="date" value={recupForm.date_debut} onChange={e=>setRecupForm(p=>({...p,date_debut:e.target.value}))}
                    style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
                </div>
                <div style={{flex:1}}>
                  <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:4}}>Au</label>
                  <input type="date" value={recupForm.date_fin} onChange={e=>setRecupForm(p=>({...p,date_fin:e.target.value}))}
                    style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
                </div>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:4}}>Heures à récupérer</label>
                <input type="number" step="0.5" value={recupForm.heures} onChange={e=>setRecupForm(p=>({...p,heures:e.target.value}))}
                  placeholder="Ex: 3.5"
                  style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
              </div>
              <textarea value={recupForm.motif} onChange={e=>setRecupForm(p=>({...p,motif:e.target.value}))} placeholder="Motif..."
                rows={3} style={{width:"100%",padding:"9px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none",resize:"vertical",fontFamily:"inherit"}}/>
              <button onClick={async()=>{
                await fetch(`${BASE}/heures/recup`,{method:"POST",headers:h(),body:JSON.stringify(recupForm)});
                setRecupForm({date_debut:"",date_fin:"",heures:"",motif:""});
                load();
              }} disabled={!recupForm.date_debut||!recupForm.heures}
                style={{padding:"11px",borderRadius:10,background:T.gradient||T.accent,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
                📤 Soumettre la demande
              </button>
            </div>
          </div>
          {/* Soldes par technicien */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:20}}>
            <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:16}}>💰 Soldes récupération</div>
            {dashboard.map(t=>{
              const solde=(parseFloat(t.recup_acquises)||0)-(parseFloat(t.recup_prises)||0);
              return(
                <div key={t.id} style={{display:"flex",alignItems:"center",gap:12,marginBottom:12,paddingBottom:12,borderBottom:`1px solid ${T.border}`}}>
                  <div style={{width:36,height:36,borderRadius:"50%",background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:T.accent,flexShrink:0}}>
                    {t.nom.split(" ").map(n=>n[0]).join("").slice(0,2)}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{t.nom}</div>
                    <div style={{fontSize:11,color:T.muted}}>Acquis: {fmtH(t.recup_acquises)} · Pris: {fmtH(t.recup_prises)}</div>
                  </div>
                  <div style={{fontSize:16,fontWeight:800,color:solde>0?"#10b981":solde<0?"#ef4444":T.muted}}>{solde>0?"+":""}{fmtH(Math.abs(solde))}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
